<template>
  <div v-bind:class="bodyClassObject">
    <div class="wrapper">
      <HeaderComponent></HeaderComponent>
      <MenuComponent active="dashboard"></MenuComponent>
      <HomeContentComponent></HomeContentComponent>
      <FooterComponent></FooterComponent>
    </div>
  </div>
</template>

<script>
import MenuComponent from './Menu';
import HomeContentComponent from './HomeContent';
import HeaderComponent from './Header';
import FooterComponent from './Footer';

export default {
  name: 'Home',
  data () {
    return {
      msg: 'home'
    };
  },
  components: {
    HomeContentComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent
  },
  computed: {
    bodyClassObject: function () {
      return {
        'skin-blue': window.application === 'cabinet',
        'skin-green': window.application !== 'cabinet'
      };
    }
  }
};
</script>

<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
